import SearchOffIcon from '@mui/icons-material/SearchOff';
import { Box, Button, Typography } from '@mui/material';
import { useRouter } from '@tanstack/react-router';
import type { FC, JSX } from 'react';

export const NotFoundError: FC = (): JSX.Element => {
  const router = useRouter();

  const handleGoHome = (): void => {
    void router.navigate({ to: '/' });
  };

  const handleGoBack = (): void => {
    void router.history.back();
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="50vh"
      gap={4}
      p={4}
      textAlign="center"
    >
      <SearchOffIcon sx={{ fontSize: 64, color: 'custom.textGrey' }} />
      <Typography variant="h2">Page Not Found</Typography>
      <Typography variant="body1" color="custom.textGrey">
        The page you are looking for does not exist or has been moved.
      </Typography>
      <Box display="flex" gap={2}>
        <Button variant="contained" onClick={handleGoHome}>
          Go Home
        </Button>
        <Button variant="outlined" onClick={handleGoBack}>
          Go Back
        </Button>
      </Box>
    </Box>
  );
};
